import React from "react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthStore from "../../store/AuthStore";
// import SettingsStore from "../../store/SettingsStore";
import UserStore from "../../store/UserStore";
import { setCookie } from "../../utils/cookie";
import { getOffshoreData } from "../../utils/functions";
import { OFFSHORE } from "../../utils/constants";

const SFLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    UserStore.getSfLoginDetais({
      token: searchParams.get("token"),
      userId: searchParams.get("userId"),
      empId: searchParams.get("empId"),
      onSuccess: () => {
        if (
          UserStore.userData?.isheldaway === false &&
          UserStore.userData?.investmentHeldWith === "2"
        ) {
          // SettingsStore.callInvestmentsHeldWith("1");
        }
        AuthStore.getHealthCheckData(
          UserStore?.userData?.user_id,
          (data) => {
            if (data?.[0] && data?.[0]?.data === "0") {
              setCookie("showpopup", "1");
            } else {
              setCookie("showpopup", "0");
            }
          },
          (error) => {
            setCookie("showpopup", "1");
          },
        );
        UserStore.setIsSalesForceLogin(true);
        const { isOffshoreOnly, navigateTo } = getOffshoreData();

        navigate(navigateTo, {
          state: isOffshoreOnly ? { from: OFFSHORE } : {},
        });
        AuthStore.updateIsfirstTimeFamilySelected(true);

        // navigate(`/${homePageRoute}`);
      },
    });
    // eslint-disable-next-line
  }, []);
  return <div></div>;
};

export default SFLogin;
